import React, { useState, useContext } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from '@material-ui/core/styles';
import { language } from "config";
import AlertDialog from '../components/AlertDialog';
import { FirebaseContext } from 'common';
import {
  Card,
  CardContent,
  CssBaseline,
  TextField,
  Typography,
  Container,
} from '@material-ui/core';
import PaymentGateway from './SelectGateway';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    width: 192,
    height: 192
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const MyPlans = () => {
  const { api } = useContext(FirebaseContext);
  const auth = useSelector(state => state?.auth);
  const [planId, setPlanId] = useState('');
  // const dispatch = useDispatch();
  const classes = useStyles();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  // const user = auth?.info?.profile
  const plandata = useSelector(state => state.plandata);

  const plans = plandata?.plans?.map((plan) => {
    return (
      {
        value: plan?.id,
        label: plan?.plan_description,
      }
    )
  });
  const [paymentData , setPaymentData] = useState({})
  const payNow = () => {
    if (planId) {
      const plan = plandata.plans.find(plan => plan.id === planId)
      setPaymentData({
        data: {
          planId,
        },
        amount: plan.plan_price,
        paymentType:"subscription"
      })
    } else {
      setCommonAlert({open: true, msg:"Plan Id required"})
    }
  }
  const handleAlertClose = () => {
    setCommonAlert({ open: false, msg: "" })
  };

  const subscription = auth?.info?.profile && auth?.info?.profile?.subscription ? auth?.info?.profile?.subscription : null;
  const getLocalDate = (date) => {
    if (date) {
      const d = new Date(date.toLocaleString());
      const year = d.getFullYear()
      const month = d.getMonth()
      const day = d.getDate()
      return `${day}/${month+1}/${year}`
    }
    return 'Invalid Date'
  }
  return (
    auth.loading ? <CircularLoading /> :
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Card style={{ minWidth: 275, margin: 10, padding: 10 }}>
          <CardContent>
            <Typography variant="h6">{language.my_plans}</Typography>
            {subscription ? <>
              <Typography sx={{ fontSize: 14 }} >PRO ΠΛΑΝΟ: {subscription.name}</Typography>
              <Typography sx={{ fontSize: 14 }} >Συνολικά Deliveries: {subscription.total_deliveries}</Typography>
              <Typography sx={{ fontSize: 14 }} >Σε Χρήση Deliveries: {subscription.used_deliveries}</Typography>
              <Typography sx={{ fontSize: 14 }} >Υπόλοιπα Deliveries: {subscription.total_deliveries-subscription.used_deliveries}</Typography>
              <Typography sx={{ fontSize: 14 }} >Έναρξη: {getLocalDate(subscription.start_date || null)}</Typography>
              <Typography sx={{ fontSize: 14 }} >Λήξη: {getLocalDate(subscription.end_date || null)}</Typography>
              <Typography sx={{ fontSize: 14 }} >Τιμή: {subscription.price}</Typography>
            </> :
              <Typography sx={{ fontSize: 14 }} >{language.no_subscription}</Typography>
            }
          </CardContent>
        </Card>
        <Card style={{ minWidth: 275, margin: 10, padding: 10 }}>
          <div className={classes.paper}>
            <Typography component="h1" variant="h5" sx={{ mb: 1.5 }}>
              {language.new_subscription}
            </Typography>
            <TextField style={{ width: '100%', margin: 10 }}
              color="success"
              id="proplans"
              select
              label={language.delivery_plans}
              value={planId}
              onChange={(e) => setPlanId(e.target.value)}
              SelectProps={{
                required: true,
              }}
              //helperText=""
              variant="standard"
            >
              {plandata?.loading && <option value="">
                Loading...
              </option>}
              {!plandata?.loading && plans?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
            <Button round
              onClick={payNow}
              fullWidth
              disabled={!planId}
              variant="contained"
              color="success"
              className={classes.submit}
            >
              {language.new_subscription}
            </Button>
          </div>
        </Card>
        <AlertDialog open={commonAlert.open} onClose={handleAlertClose}>{commonAlert.msg}</AlertDialog>
        <PaymentGateway paymentData={paymentData} />  
      </Container>
  );
};

export default MyPlans;
